module.exports = __webpack_public_path__ + "img/triangle-right.2778fd8c.webp";